import axios from 'axios';
import { baseUrl } from './config';

export const authorize = async (address: string, SK: string, signature: string) => {
    const url = `${baseUrl}/auth/authorize`;
    const res = await axios.post(url, { address: address.toLowerCase(), SK, signature });
    return res.data.data.token;
};
